import { default as OrgBusinessIcon } from "@material-ui/icons/Business";
import { OrgCreate } from "./OrgCreate";
import { OrgEdit } from "./OrgEdit";
import { OrgList } from "./OrgList";
import { OrgShow } from "./OrgShow";

export const ALL_PARTICIPANT_TYPES = [
  {
    id: "None",
    name: "portal.label.participant.None",
    helperText: "portal.label.helperText.participant.None",
  },
  {
    id: "Distributor",
    name: "portal.label.participant.Distributor",
    helperText: "portal.label.helperText.participant.Distributor",
  },
  {
    id: "DirectConnect",
    name: "portal.label.participant.DirectConnect",
    helperText: "portal.label.helperText.participant.DirectConnect",
  },
  {
    id: "Generator",
    name: "portal.label.participant.Generator",
    helperText: "portal.label.helperText.participant.Generator",
  },
  {
    id: "Trader",
    name: "portal.label.participant.Trader",
    helperText: "portal.label.helperText.participant.Trader",
  },
];

export const OrgsResourceInternal = {
  list: OrgList,
  show: OrgShow,
  edit: OrgEdit,
  create: OrgCreate,
  icon: OrgBusinessIcon,
};

export const OrgIcon = OrgBusinessIcon;
export * from "./OrgCreate";
export * from "./OrgList";
export * from "./OrgShow";
